'use strict';exports.__esModule = true;var ROOMS = [
{
  label: '1',
  value: '1' },

{
  label: '2',
  value: '2' },

{
  label: '3',
  value: '3' },

{
  label: '4',
  value: '4' },

{
  label: '5',
  value: '5' },

{
  label: '6+',
  value: '6' }];exports.default =



ROOMS;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddPropertiesToProjectForm/constants.js
// module id = 2947
// module chunks = 0